const author = "Nameer Rizvi";

module.exports = author;
